import React from 'react'
import { Link } from 'react-router-dom'

export const NoxsysAbout: React.FC = () => {
    return (
        <div className="flex flex-col w-full lg:w-[940px] gap-4">
            <h1 className="font-bold text-2xl text-center">
                NOXSYS - эффективное управление закупками по 223-ФЗ
            </h1>
            <div className="flex flex-col md:grid md:grid-cols-2 md:auto-rows-fr gap-4">
                <div className="card_item card_item_light">
                    <h2>Интерактивные реестры</h2>
                    <p>
                        Реестры, автоматизирующие полный цикл планирования
                        закупок, от создания и согласования до размещения в ЕИС
                    </p>
                </div>
                <div className="card_item card_item_light">
                    <h2>Дашборды и аналитика</h2>
                    <p>
                        Получите визуальное представление ключевых показателей в
                        режиме реального времени
                    </p>
                </div>
            </div>
            <div className="flex flex-col md:grid md:grid-cols-3 md:auto-rows-fr gap-4">
                <div className="card_item card_item_light">
                    <h2>Интеграция с ЕИС</h2>
                    <p>
                        Система NOXSYS обеспечивает полноценную интеграцию с ЕИС
                        (
                        <Link to="https://zakupki.gov.ru" target="_blank">
                            zakupki.gov.ru
                        </Link>
                        )
                    </p>
                </div>
                <div className="card_item card_item_light">
                    <h2>Работа в команде</h2>
                    <p>
                        Одновременная работа до 1 000 пользователей в режиме
                        реального времени
                    </p>
                </div>
                <div className="card_item card_item_light">
                    <h2>ИИ в закупках</h2>
                    <p>
                        Интеллектуальные подсказки на основе нейросетевых
                        технологий
                    </p>
                </div>
            </div>
        </div>
    )
}
